export const NOTIFICATION_TYPES = {
  COMMENT: "comment",
  NEW_FRIEND_REQUEST: "new friend request",
  ACCEPED_FRIEND_REQUEST: "accepted friend request",
  LIKED_REVIEW: "liked review",
};

export const FRIEND_REQUEST_STATUSES = {
  APPROVED: "approved",
  INCOMING: "incoming",
  OUTGOING: "outgoing",
};

export const MAX_CONTENT_WIDTH = "1200";

export const USER_WORK_RELATIONSHIPS = {
  SAVED_FOR_LATER: "savedForLater",
  ENGAGED: "engaged",
};
